import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showSnackbar } from "./snackbar";
import { getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import secureLocalStorage from "react-secure-storage";

const baseUrl = getBaseUrl();

export const userFeedback = createAsyncThunk(
  "userFeedback",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/sessions/${payload.sessionId}/chats/${payload.chatId}/feedback`,
        payload.data,
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({ includeIncomingEmail: true }),
            client: payload.client ? payload.client : "UT",
          },
          withCredentials: true,
        },
      );

      dispatch(
        showSnackbar({
          message: "Completed Successfully!",
          severity: "success",
        }),
      );

      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Save Failed!", severity: "error" }));

      // safer error payload
      const msg =
        error?.response?.data?.detail ||
        error?.response?.statusText ||
        error?.message ||
        "Unknown error";
      return rejectWithValue(msg);
    }
  },
);

const userFeedbackSlice = createSlice({
  name: "user-feedback",
  initialState: {
    isLoading: false,
    userFeedback: "",
    isError: false,
    error: null,
    success: false,
  },
  reducers: {
    resetUserFeedbackState: (state) => {
      state.isLoading = false;
      state.userFeedback = "";
      state.isError = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userFeedback.pending, (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(userFeedback.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.userFeedback = action.payload;
    });
    builder.addCase(userFeedback.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
      state.success = false;
    });
  },
});

export const { resetUserFeedbackState } = userFeedbackSlice.actions;
export default userFeedbackSlice.reducer;
